import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import * as S from './Header.styles';
import Nav from './Nav';

const Header = () => {
	const [currentFirstBackgroundIndex, setCurrentFirstBackgroundIndex] =
		useState<number>(0);
	const [currentSecondBackgroundIndex, setCurrentSecondBackgroundIndex] =
		useState<number>(-1);
	const [backgroundOpacity, setBackgroundOpacity] = useState<number>(0);
	const [height, setHeight] = useState<number>(0);

	const location = useLocation();

	const headerRef = useRef(null);

	// Load images from assets
	const headerImagesModules = import.meta.glob(
		'../../assets/images/header/*.{png,jpg,jpeg,webp}',
		{ eager: true }
	);
	const backgroundUrls = Object.values(headerImagesModules).map(
		(mod: any) => mod.default
	);

	const backgroundOpacityRef = useRef(backgroundOpacity);
	const currentFirstBackgroundIndexRef = useRef(currentFirstBackgroundIndex);

	useEffect(() => {
		backgroundOpacityRef.current = backgroundOpacity;
	}, [backgroundOpacity]);

	useEffect(() => {
		currentFirstBackgroundIndexRef.current = currentFirstBackgroundIndex;
	}, [currentFirstBackgroundIndex]);

	useEffect(() => {
		let intervalId: NodeJS.Timeout;
		let timeoutId: NodeJS.Timeout;

		if (backgroundUrls.length > 0) {
			const intervalFn = () => {
				setBackgroundOpacity((prevOpacity) => (prevOpacity + 1) % 2);

				timeoutId = setTimeout(() => {
					if (backgroundOpacityRef.current === 1) {
						setCurrentSecondBackgroundIndex(
							(prevIndex) =>
								(prevIndex + 2) % backgroundUrls.length
						);
					} else {
						setCurrentFirstBackgroundIndex(
							(prevIndex) =>
								(prevIndex + 2) % backgroundUrls.length
						);
					}
				}, 3000);
			};

			intervalFn();
			// intervalId = setInterval(intervalFn, 7000);
			intervalId = setInterval(intervalFn, 40000);
		}

		return () => {
			if (intervalId) {
				clearInterval(intervalId);
			}
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
		};
	}, [backgroundUrls.length]); // Dependency changed to length or empty array if stable

	useEffect(() => {
		const currentElement = headerRef.current;

		const handleResize = (entries: ResizeObserverEntry[]) => {
			for (let entry of entries) {
				setHeight(entry.target.clientHeight);
			}
		};

		const observer = new ResizeObserver(handleResize);

		if (currentElement) {
			observer.observe(currentElement);
		}

		return () => {
			if (currentElement) {
				observer.unobserve(currentElement);
			}
		};
	}, []);

	return (
		<>
			<S.StyledHeader
				ref={headerRef}
				$isHomePage={location.pathname === '/inici'}
			>
				{backgroundUrls.length > 0 && (
					<S.BackgroundContainer
						$imageUrl={
							currentFirstBackgroundIndex >= 0
								? backgroundUrls[currentFirstBackgroundIndex]
								: ''
						}
						$backgroundOpacity={backgroundOpacity}
					/>
				)}

				{backgroundUrls.length > 0 && (
					<S.BackgroundContainer
						$imageUrl={
							currentSecondBackgroundIndex >= 0
								? backgroundUrls[currentSecondBackgroundIndex]
								: ''
						}
						$backgroundOpacity={backgroundOpacity === 0 ? 1 : 0}
					/>
				)}

				<Nav headerHeight={height} />
			</S.StyledHeader>
		</>
	);
};

export default Header;
